import Vue from 'vue';
import { BiFi } from '@bifrost-platform/bifi';

Vue.prototype.$BiFi = BiFi;

export default BiFi;
